import { P, Segments } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Path } from "paper";
export class Triangle {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 8, maxX: 250,
                minY: 8, maxY: 250,
                toAppearance: (f, p) => f({
                    width: p.x * 2,
                    height: p.y * 2
                }),
                fromAppearance: a => P(a.width / 2, a.height / 2),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { width, height } = appearance;
        const apexPosition = P(appearance.apex * width / 2, -height / 2);
        const graphic = new Path(Segments([[apexPosition.x, apexPosition.y]], [[width / 2, height / 2]], [[-width / 2, height / 2]]));
        graphic.close();
        BasicShapes.applyStyle(graphic, appearance);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
        };
    }
}
Triangle.properties = {
    label: "Triangle",
    defaultAppearance: Object.assign({ width: 200, height: 200, apex: 0 }, BasicShapes.defaultAppearance),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "slider", key: "apex", label: "Apex position",
            min: -1, max: 1, step: 0.01,
        }
    ],
};
